"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");

var CompetitorPriceIndexConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(CompetitorPriceIndexConverter, _DataObjectConverter_);

  function CompetitorPriceIndexConverter() {
    _classCallCheck(this, CompetitorPriceIndexConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(CompetitorPriceIndexConverter).apply(this, arguments));
  }

  return CompetitorPriceIndexConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.CompetitorPriceIndexConverter = CompetitorPriceIndexConverter;